module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar left sidebar-size-2 sidebar-offset-0 sidebar-skin-blue sidebar-visible-desktop sidebar-visible-mobile"
  }, [_c('div', {
    staticClass: "split-vertical"
  }, [_c('div', {
    staticClass: "split-vertical-body"
  }, [_c('div', {
    staticClass: "split-vertical-cell"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "sidebar-tabs-menu"
    }
  }, [_c('div', {
    attrs: {
      "data-scrollable": ""
    }
  }, [_c('ul', {
    staticClass: "sidebar-menu sm-icons-left",
    staticStyle: {
      "margin-top": "18px"
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-hdd-o",
    staticStyle: {
      "color": "white"
    }
  }), _vm._v(" "), _c('span', [_vm._v("运行状态")])])], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "sidebar-menu sm-icons-left",
    staticStyle: {
      "margin-top": "18px"
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/channel"
    }
  }, [_c('i', {
    staticClass: "fa fa-link",
    staticStyle: {
      "color": "white"
    }
  }), _vm._v(" "), _c('span', [_vm._v("链路编辑")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/template"
    }
  }, [_c('i', {
    staticClass: "fa fa-magic",
    staticStyle: {
      "color": "white"
    }
  }), _vm._v(" "), _c('span', [_vm._v("模板管理")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/version"
    }
  }, [_c('i', {
    staticClass: "fa fa-inbox",
    staticStyle: {
      "color": "white"
    }
  }), _vm._v(" "), _c('span', [_vm._v("备份还原")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-block"
  }, [_c('div', {
    staticStyle: {
      "color": "#d9e7f1",
      "font-size": "12px",
      "margin-top": "12px",
      "margin-bottom": "8px"
    }
  }, [_vm._v("\n                CPU " + _vm._s(_vm.formatPercent(_vm.process.Cpu)) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-success",
    style: (_vm.temp),
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "{{process.Cpu}}",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#d9e7f1",
      "font-size": "12px",
      "margin-top": "10px",
      "margin-bottom": "6px"
    }
  }, [_vm._v("\n                内存 " + _vm._s(_vm.formatPercent(_vm.process.Mem)) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-danger",
    style: (_vm.data),
    attrs: {
      "role": "progressbar",
      "aria-valuenow": "{{process.Mem}}",
      "aria-valuemin": "0",
      "aria-valuemax": "100"
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "sidebar-menu sm-icons-left sm-icons-block",
    staticStyle: {
      "margin-top": "18px"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.store.showRestart($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    staticStyle: {
      "color": "white"
    }
  }), _vm._v(" "), _c('span', [_vm._v("重新启动")])])])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ead89a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/framework/Sidebar.vue
// module id = 90
// module chunks = 0